<template>
  <div class="falcon-chart" ref="chart">

  </div>
  <!--    <canvas ref="chart" width="400" height="400" style="height: 400px;"></canvas> -->
</template>

<script>
import {CHART_COLORS, FONT_FAMILY} from "./chartColors";
import {formatDollars, formatDollarsNoZeros, formatMillionsDollars} from "../../moneyUtils";
import echarts from 'echarts';
import {xAxisStyle} from "@/shared/components/charts/charts-utils";

export default {
  name: 'fourmethodsValuationGraph',
  data() {
    return {
      graphData: this.data,
    }
  },
  props: ['stepup', 'risk_mitigation', 'checklist', 'scorecard', 'avg'],
  mounted() {
    var myChart = echarts.init(this.$refs['chart'], null, {
      renderer: 'svg'
    },);

    // specify chart configuration item and data
    var option = {
      tooltip: {
        show: true
      },
      textStyle: {
        fontFamily: FONT_FAMILY
      },
      xAxis: {
        axisLine: {
          lineStyle: {
            color: '#899094'
          },
        },
       axisLabel: {
          fontSize: 12,
        },
        axisTick: {
          show: false,
        },
        tickOptions: {showGridLine: false},
        type: 'category',
        data: [xAxisStyle(`${formatDollarsNoZeros(this.stepup)}\nStepup`),
               xAxisStyle(`${formatDollarsNoZeros(this.risk_mitigation)}\nRisk M.`),
               xAxisStyle(`${formatDollarsNoZeros(this.checklist)}\nChecklist`),
               xAxisStyle(`${formatDollarsNoZeros(this.scorecard)}\nScorecard`),
               xAxisStyle(`${formatDollarsNoZeros(this.avg)}\nAvg`)]
      },
      yAxis: {
        axisLabel: {
          show: false,
          color: '#899094',
          formatter: formatMillionsDollars
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#fff'

          },
        },
        splitLine: {
          lineStyle: {
            color: ['#E3E9EA'],
          }
        },
      },
      series: [

        {
          type: 'bar',
          name: '',
          barWidth: 60,
          data: [
            this.stepup,
            this.risk_mitigation,
            this.checklist,
            this.scorecard,
            {
              value: this.avg,
              itemStyle: {
                color: CHART_COLORS.MAIN
              }
            }
          ],
          tooltip: {
            formatter: function (params, ticket, callback) {
              return formatDollars(params['value'])
            },
          },
          itemStyle: {
            color: CHART_COLORS.SECONDARY_4,
            barBorderRadius: [5, 5, 0, 0]
          },
        }
      ]
    };

    myChart.setOption(option);

  },
  methods: {},
  computed: {},
}
</script>

<style scoped>
.falcon-chart {
  width: 100%;
  height: 400px;
}
</style>
